var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7487_99556)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#393ABD",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7582 11.6641H20.9375V14.6985H22.7582V11.6641Z",
    fill: "#393ABD",
    stroke: "black",
    strokeWidth: 0.00666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9593 12.9001L16.6719 14.1875L18.8175 16.3332L20.1049 15.0458L17.9593 12.9001Z",
    fill: "#393ABD",
    stroke: "black",
    strokeWidth: 0.00666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4719 17.1641H15.4375V18.9847H18.4719V17.1641Z",
    fill: "#393ABD",
    stroke: "black",
    strokeWidth: 0.00666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2905 26.2109V31.2536H16.5703V32.4667C16.5703 35.6984 19.1994 38.3275 22.4316 38.3275H28.702C31.9343 38.3275 34.5633 35.6984 34.5633 32.4667V26.2109H20.2905Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5659 26.2129H31.4531C31.4531 25.3542 32.151 24.6562 33.0092 24.6562C33.8679 24.6562 34.5659 25.3542 34.5659 26.2129Z",
    fill: "#FFCD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8477 24.2832V26.2119H27.7344V24.2832C27.7344 23.4251 28.4323 22.7266 29.291 22.7266C30.1492 22.7266 30.8477 23.4251 30.8477 24.2832Z",
    fill: "#FFCD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.129 22.5254V26.2153H24.0156V22.5254C24.0156 21.6673 24.7142 20.9688 25.5723 20.9688C26.4304 20.9688 27.129 21.6673 27.129 22.5254Z",
    fill: "#FFCD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4096 18.0723V26.2107H20.2969V18.0723C20.2969 17.2135 20.9948 16.5156 21.8529 16.5156C22.7117 16.5156 23.4096 17.2135 23.4096 18.0723Z",
    fill: "#FFCD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6836 27.002V31.2532H16.5703V27.002C16.5703 26.1438 17.2682 25.4453 18.127 25.4453C18.9851 25.4453 19.6836 26.1438 19.6836 27.002Z",
    fill: "#FFCD00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7487_99556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectIcon);
export default __webpack_public_path__ + "static/media/select-icon.7896341d6d15a89e9c36261c3de1436d.svg";
export { ForwardRef as ReactComponent };